import IssuesCard from "./IssuesCard"

export default  IssuesCard;
